/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const ApiKeyCreateRequest: core.serialization.Schema<
    serializers.ApiKeyCreateRequest.Raw,
    Omit<Truvity.ApiKeyCreateRequest, 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace ApiKeyCreateRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        labels?: Record<string, string> | null;
    }
}
